import { Skeleton } from "@/components/ui/skeleton";

export const FlightCardSkeleton = ({ isSmall = false }: { isSmall?: boolean }) => {
  return (
    <div className={`w-full p-4 ${isSmall ? 'h-[150px]' : 'h-[200px]'} border rounded-lg mb-4`}>
      <div className="flex justify-between">
        <div className="space-y-3 w-1/4">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-6 w-1/2" />
        </div>
        <div className="space-y-3 w-1/4">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-6 w-1/2" />
        </div>
        <div className="space-y-3 w-1/4">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-6 w-1/2" />
        </div>
        <div className="space-y-3 w-1/4">
          <Skeleton className="h-10 w-full" />
        </div>
      </div>
    </div>
  );
};

const FlightListSkeleton = ({ count = 3, isSmall = false }: { count?: number, isSmall?: boolean }) => {
  return (
    <div className="w-full space-y-4">
      {/* Flight Route Header */}
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <Skeleton className="h-7 w-32" /> {/* City names */}
          <Skeleton className="h-6 w-6" /> {/* Arrow */}
          <Skeleton className="h-7 w-32" /> {/* City names */}
        </div>
        <Skeleton className="h-5 w-40" /> {/* Date */}
      </div>

      {/* Flight Info Cards */}
      <div className="flex items-center justify-between mt-6 mb-8">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2 px-4 py-2 rounded-lg border">
            <Skeleton className="h-5 w-5" /> {/* Icon */}
            <Skeleton className="h-5 w-20" /> {/* Text */}
          </div>
          <div className="flex items-center gap-2 px-4 py-2 rounded-lg border">
            <Skeleton className="h-5 w-5" /> {/* Icon */}
            <Skeleton className="h-5 w-20" /> {/* Text */}
          </div>
          <div className="flex items-center gap-2 px-4 py-2 rounded-lg border">
            <Skeleton className="h-5 w-5" /> {/* Icon */}
            <Skeleton className="h-5 w-20" /> {/* Text */}
          </div>
        </div>
        
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 px-4 py-2 rounded-lg border bg-red-50">
            <Skeleton className="h-5 w-5" /> {/* Icon */}
            <Skeleton className="h-5 w-20" /> {/* Text */}
            <Skeleton className="h-5 w-5" /> {/* Arrow */}
          </div>
        </div>
      </div>

      {/* Flight Cards */}
      {Array.from({ length: count }).map((_, index) => (
        <FlightCardSkeleton key={index} isSmall={isSmall} />
      ))}
    </div>
  );
};

export default FlightListSkeleton;
